export default __webpack_public_path__ + "static/media/1G.67074ca1.png";